// extracted by mini-css-extract-plugin
module.exports = {"historycheckbox":"Container_historycheckbox_3AGy-"};